import React, { PropsWithChildren } from 'react';
import * as S from './ModalSheet.styles';
import { useResponsive } from '@/hooks/useResponsive';
import { Modal } from '@/components/UI/Modal';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { Button } from '@/components/UI/Button/Button';

interface ModalSheetProps {
  dataTestId?: string;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  isInPortal?: boolean;
  isBodyScrollLocked?: boolean;
  background?: string;
  className?: string;
}

export const ModalSheet = ({
  dataTestId,
  isOpen,
  onClose,
  title,
  children,
  isInPortal = false,
  isBodyScrollLocked = false,
  background,
  className,
}: PropsWithChildren<ModalSheetProps>) => {
  const { isDesktop } = useResponsive();

  if (isDesktop) {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        maxWidth={600}
        isScrollLocked={isBodyScrollLocked}
        isInPortal={isInPortal}
        background={background}
        className={className}
      >
        <S.ModalSheetContent data-testid={dataTestId}>
          {title && (
            <S.ModalSheetHeader>
              <S.ModalSheetTitle>{title}</S.ModalSheetTitle>
              <Button
                appearance="transparent"
                hasPadding={false}
                onClick={onClose}
              >
                <S.ModalSheetCloseIcon />
              </Button>
            </S.ModalSheetHeader>
          )}
          {children}
        </S.ModalSheetContent>
      </Modal>
    );
  }

  return (
    <BottomSheet
      dataTestId={dataTestId}
      isOpen={isOpen}
      close={onClose}
      title={title}
      headPaddingTop={15}
      isTitleCentered={false}
      hasHeadBorder={false}
      isPageLocked={isBodyScrollLocked}
      isInPortal={isInPortal}
      background={background}
      className={className}
    >
      {children}
    </BottomSheet>
  );
};
